module.exports = __webpack_public_path__ + "media/images/favicon/secondary/apple-icon-120x120-ddbd47580b463fded962ae43c1911fff.png";